import { getMarketByJunoMarketCode } from "@ilc-technology/env-utils";
import { EFComProgramCodes, ProgramCodes, Quote, SegmentType } from "../Types";

export function resolveEfcomProgramCode(
  program: string | undefined,
  programs: Record<string, string>,
  defaultProgramCode: string
): string {
  return program ? programs[program] ?? defaultProgramCode : defaultProgramCode;
}

export function resolveMartechMarketCode(junoMarketCode: string): string {
  return getMarketByJunoMarketCode(junoMarketCode)?.marketCode?.toLowerCase() || "";
}

export function resolveJunoProgram(program?: string): string {
  return program?.toLowerCase() || "";
}

export function resolveMartechProduct(
  baseProduct: string,
  junoProgram: string,
  isGroupCourse: boolean,
  courseCategory?: string | null
): string {
  const shouldMapIlcToLt =
    isGroupCourse && !!courseCategory && junoProgram === ProgramCodes.ILC.toLowerCase();

  return (shouldMapIlcToLt ? EFComProgramCodes.LT : baseProduct).toLowerCase();
}

export type QuoteMartechContentParams = {
  market: string;
  junoProgram: string;
  efcomProduct: string;
  courseContentProduct: string;
};

export function getQuoteMartechContentParams(input: {
  quote: Quote;
  quoteData: Quote;
  programs: Record<string, string>;
  defaultProgramCode: string;
  isGroupCourse: boolean;
}): QuoteMartechContentParams {
  const { quote, quoteData, programs, defaultProgramCode, isGroupCourse } = input;

  const market = resolveMartechMarketCode(quoteData.market);
  const junoProgram = resolveJunoProgram(quoteData.program);
  const efcomProgramCode = resolveEfcomProgramCode(quoteData.program, programs, defaultProgramCode);
  const efcomProduct = efcomProgramCode.toLowerCase();

  const courseListSegment = quote.segments.find((segment) => segment.type === SegmentType.Course);
  const courseContentProduct = resolveMartechProduct(
    efcomProduct,
    junoProgram,
    isGroupCourse,
    courseListSegment?.courseCategory
  );

  return {
    market,
    junoProgram,
    efcomProduct,
    courseContentProduct,
  };
}
